import {Heading} from "../../../components";
import FeatureTabs from "../../../components/FuatereTabs";
import React, {Suspense} from "react";
import {useTranslation} from "react-i18next";

export default function  Feature() {

    const {t} = useTranslation();

    const FeatureTabsGrid =[
        {
            tabsNumber: "01",
            title: t("opportunities.title.1"),
            description: t("opportunities.description.1"),
            icon: "/images/feature_1.svg",
        },
        {
            tabsNumber: "02",
            title: t("opportunities.title.2"),
            description: t("opportunities.description.2"),
            icon: "/images/feature_2.svg",
        },
        {
            tabsNumber: "03",
            title: t("opportunities.title.3"),
            description: t("opportunities.description.3"),
            icon: "/images/feature_3.svg",
        },
    ];

    return (
        <>
            <section id="Feature">
                <div className="flex flex-col items-center px-6 sm:px-[16px]">
                    <div className="container-xs flex flex-col items-start gap-10">
                        <Heading
                            size="desktop_heading_4"
                            as="h2"
                            className="font-medium text-[#191c2fe5] leading-[33.6px] gap-4 uppercase">
                            {t("opportunities.head_title")}
                        </Heading>
                        <div className="grid lg:grid-cols-3 grid-cols-1 gap-5 sm:gap-4 self-stretch">
                            <Suspense fallback={<div>Loading </div>}>
                                {FeatureTabsGrid.map((d, index) => (
                                    <FeatureTabs {...d} key={"grid" + index}/>
                                ))}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}